var _defs, _defs2, _defs3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangepieceRatehubwise({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3710,
    height: 3710
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F7FA"
    },
    d: "M2933.245,975.222c-348.232-476.646-944.435-506.422-981.297-508.132 c-470.212-21.814-805.873,217.97-926.906,307.24c-87.858,64.802-209.802,156.314-323.626,317.208 c-51.939,73.417-232.717,345.785-235.596,712.266c-4.475,569.733,424.347,940.517,502.201,1005.119 c421.125,349.446,1157.657,523.448,1710.122,124.839C3326.979,2465.62,3320.393,1505.136,2933.245,975.222z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -4016.5146,
    y1: -3077.438,
    x2: -3544.3064,
    y2: -58.6704,
    gradientTransform: "matrix(-0.6647 -0.7471 -0.7471 0.6647 -1588.8998 935.8854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#E38DDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9571F6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M2201.226,2897.739c-16.312-5.712-46.763-32.518-51.82-42.779 c-33.653-68.283-104.966-192.036-83.724-269.657c3.628-13.257,66.253-13.039,77.265-23.583 c39.962-9.553,54.417-10.388,87.947-38.133c98.988-81.91-40.256-304.425,180.936-325.548 c162.02-15.472,279.307,64.005,312.818-175.358s311.434-629.71,525.76-412.504c123.002,124.656-64.523,294.596-22.237,458.115 c40.183,155.385-43.891,258.548-211.103,311.365c-167.212,52.816-101.125,134.554-85.954,277.355 c18.225,171.534-234.703,147.791-350.539,126.868C2487.296,2767.03,2238.407,2787.06,2201.226,2897.739z"
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000021815362569675482550000009361672980634377397_",
    d: "M2031.993,2556.966 c12.539,118.14,20.432,238.874,32.417,357.914c64.977,19.331,141.879,40.487,173.686-37.702 c44.22-108.706,249.609-110.797,342.721-93.466c115.244,21.45,368.653,44.664,350.315-126.729 c-15.267-142.684-81.25-224.548,85.948-277.335c167.198-52.787,251.244-155.969,211.093-311.366 c-42.254-163.531,145.211-333.379,22.235-458.109c-214.279-217.336-492.364,173.376-525.705,412.422 c-33.341,239.046-151.39,160.877-312.724,175.205c-220.256,19.561-84.468,247.779-180.028,323.771 C2157.037,2581.143,2112.8,2558.022,2031.993,2556.966z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000154418904004042943130000009020366850496914085_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000021815362569675482550000009361672980634377397_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000154418904004042943130000009020366850496914085_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFDFE"
    },
    d: "M2108.193,2727.281l-0.857-3.431c275.948-69.048,523.298-220.762,715.313-438.745 c182.703-207.408,312.885-470.422,376.474-760.605l3.456,0.757c-63.717,290.769-194.175,554.328-377.276,762.188 C2632.814,2505.967,2384.843,2658.059,2108.193,2727.281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFDFE"
    },
    d: "M2946.902,2727.379c-133.962-77.652-374.494-129.827-536.111-116.302l-0.297-3.525 c162.274-13.594,403.687,38.808,538.184,116.765L2946.902,2727.379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFDFE"
    },
    d: "M2215.668,2699.08l-1.776-3.062c72.93-42.339,121.654-119.919,144.816-230.583 c16.981-81.135,20.084-177.839,9.216-287.426l3.525-0.349c10.899,109.946,7.778,207.011-9.278,288.499 C2338.794,2577.848,2289.504,2656.213,2215.668,2699.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFDFE"
    },
    d: "M2850.159,2256.917l-1.928-2.965c133.309-86.845,300.562-82.265,417.405-63.132l-0.573,3.494 C3148.855,2175.276,2982.528,2170.688,2850.159,2256.917z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFDFE"
    },
    d: "M3051.429,1953.354l-3.4-0.981c21.314-73.948,41.418-229.049-63.427-436.969l3.158-1.593 c35.423,70.243,60.479,144.56,72.46,214.916C3074.011,1809.699,3071.053,1885.274,3051.429,1953.354z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000051346677738439832530000005759698876992836024_",
    d: "M2649.574,2775.326 c-86.931-12.784-173.775-27.566-260.46-44.339c-1.41,1.275-29.905-187.684,59.852-286.78 c177.49-191.975,57.937-364.271,23.835-466.363c-54.578-143.963-26.605-318.939,131.957-286.165 c154.477,28.225,177.909-289.799,151.247-534.8c-22.756-119.244,89.754-263.925,202.029-296.99 c114.617-36.633,228.998,38.35,264.052,276.035c53.066,275.202-147.775,441.161-222.145,579.137 c-73.177,135.448,97.053,245.037-39.963,365.049c-115.249,106.636-260.501,183.293-207.366,317.242 C2807.203,2529.782,2794.133,2638.054,2649.574,2775.326z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000020372823010928227770000011166289021344965054_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000051346677738439832530000005759698876992836024_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013879571330639275140000000933006045112486332_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.8339,
    y1: -1391.0179,
    x2: -614.3452,
    y2: 382.9664,
    gradientTransform: "matrix(-0.8674 -0.4976 -0.4976 0.8674 2274.7078 2110.0093)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000020372823010928227770000011166289021344965054_)",
      fill: "url(#SVGID_00000013879571330639275140000000933006045112486332_)"
    },
    d: " M2649.574,2775.326c-86.931-12.784-173.775-27.566-260.46-44.339c-1.41,1.275-29.905-187.684,59.852-286.78 c177.49-191.975,57.937-364.271,23.835-466.363c-54.03-143.856-25.613-299.634,120.803-301.938 c162.393-5.734,191.835-274.521,162.401-519.027c-22.756-119.244,89.754-263.925,202.029-296.99 c114.617-36.633,228.998,38.35,264.052,276.035c53.066,275.202-147.775,441.161-222.145,579.137 c-73.177,135.448,97.053,245.037-39.963,365.049c-115.249,106.636-260.501,183.293-207.366,317.242 C2807.203,2529.782,2794.133,2638.054,2649.574,2775.326z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000020372823010928227770000011166289021344965054_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFDFE"
    },
    d: "M2533.322,2786.547l-3.535-0.057c-0.024-1.679,83.062-399.241,226.295-786.106 c19.78-62.649,41.273-125.836,62.058-186.941c55.652-163.616,113.198-332.802,140.524-501.258 c30.547-188.292,19.659-357.881-33.281-518.456l3.359-1.109c53.123,161.128,64.052,331.265,33.415,520.132 c-27.375,168.747-84.969,338.077-140.669,501.83c-20.778,61.088-42.265,124.255-62.062,186.95 C2615.077,2391.422,2533.536,2784.23,2533.322,2786.547z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFDFE"
    },
    d: "M2922.08,1497.246l-2.633-2.367c96.905-107.669,213.834-260.683,276.649-342.889 c50.579-66.191,50.838-66.084,52.936-65.766l-0.273,1.748l0.722,1.576c-2.561,1.762-23.75,29.488-50.572,64.592 C3136.063,1236.384,3019.078,1389.472,2922.08,1497.246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFDFE"
    },
    d: "M2951.366,1349.561c-20.049-123.404-70.867-204.575-109.963-250.94 c-43.177-51.201-82.961-73.528-87.028-74.022c0.014,0,0.39,0.045,0.84-0.252l-1.97-2.941c0.888-0.594,1.928-0.451,4.281,0.574 c10.733,4.665,50.835,29.749,92.899,82.03c52.981,65.849,89.092,150.563,104.431,244.984L2951.366,1349.561z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFDFE"
    },
    d: "M2674.364,2253.477l-3.511-0.418c13.667-114.815-13.086-238.313-79.523-367.066 c-34.649-67.15-78.835-132.936-131.336-195.528c-3.804-4.537-5.142-6.144-5.567-6.877l3.062-1.774 c0.307,0.525,2.474,3.107,5.218,6.377c52.666,62.793,97.001,128.798,131.768,196.18 C2661.24,2013.762,2688.121,2137.949,2674.364,2253.477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFDFE"
    },
    d: "M2713.537,2132.598l-3.007-1.863c104.248-168.417,323.97-180.071,325.867-179.517l1.317,1.655 l-1.209,1.74l-0.56-1.655l-0.152,1.729c-0.007,0-0.017,0-0.031,0C3032.289,1954.688,2816.108,1966.888,2713.537,2132.598z  M3035.371,1951.261l0.567,1.671L3035.371,1951.261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFDFE"
    },
    d: "M2547.835,2721.701l-3.539-0.131c1.839-49.989-16.034-135.199-111.597-257.264 c-5.184-6.619-5.184-6.619-5.042-7.607l3.504,0.498l-1.752-0.249l1.621-0.665c0.273,0.503,2.212,2.977,4.454,5.843 C2531.708,2585.03,2549.694,2671.122,2547.835,2721.701z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFDFE"
    },
    d: "M2569.909,2627.541l-3.4-0.985c11.02-38.025,54.391-112.525,221.036-184.265 c2.301-0.992,3.78-1.626,4.309-1.897l1.617,3.148c-0.556,0.285-2.108,0.957-4.527,1.999 C2623.633,2516.705,2580.756,2590.115,2569.909,2627.541z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170265487478814038920000005409867944840442020_",
    gradientUnits: "userSpaceOnUse",
    x1: 1143.5188,
    y1: 3453.6021,
    x2: 2827.5471,
    y2: 234.3372
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170265487478814038920000005409867944840442020_)"
    },
    d: "M3046.272,1938.687 c0,584.659-473.779,1080.276-1078.241,1107.907c-627.783,28.698-1154.759-454.808-1154.759-1080.957 s526.976-1122.375,1154.759-1108.83C2572.493,869.847,3046.272,1354.028,3046.272,1938.687z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000076561900523461889290000017080617501832839078_",
    gradientUnits: "userSpaceOnUse",
    x1: 112.518,
    y1: 5558.6875,
    x2: 1796.5464,
    y2: 2339.4231
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000076561900523461889290000017080617501832839078_)"
    },
    d: "M3116.462,1938.687 c0,584.659-473.778,1080.276-1078.241,1107.907c-627.783,28.698-1154.759-454.808-1154.759-1080.957 s526.976-1122.375,1154.759-1108.83C2642.683,869.847,3116.462,1354.028,3116.462,1938.687z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052092718710744406000000010879628860609763765_",
    gradientUnits: "userSpaceOnUse",
    x1: 2591.8889,
    y1: 1296.295,
    x2: -339.2738,
    y2: 4538.8315
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052092718710744406000000010879628860609763765_)"
    },
    d: "M3049.739,1939.493 c0,550.882-446.902,1016.992-1015.949,1041.863c-589.668,25.772-1083.604-428.957-1083.604-1016.524 S1444.122,910.614,2033.79,922.152C2602.836,933.288,3049.739,1388.611,3049.739,1939.493z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1804.414,1992.284c45.764-59.399,68.652-148.229,68.652-266.516 c0-113.13-23.273-200.177-69.81-261.118c-46.55-60.939-113.275-91.408-200.178-91.408 c-177.419,0-266.129,117.516-266.129,352.526c0,115.203,23.142,203.261,69.424,264.202 c46.286,60.939,111.853,91.41,196.705,91.41C1691.524,2081.38,1758.636,2051.681,1804.414,1992.284z M1604.622,1921.701 c-25.722,0-44.356-16.066-55.923-48.212c-11.573-32.132-17.359-80.863-17.359-146.178c0-65.303,5.786-113.781,17.359-145.407 c11.568-31.627,30.202-47.441,55.923-47.441c49.371,0,74.056,64.292,74.056,192.848 C1678.678,1856.904,1653.993,1921.701,1604.622,1921.701z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2593.162,1915.145c-46.548-60.941-113.273-91.41-200.176-91.41 c-177.421,0-266.132,117.517-266.132,352.526c0,114.684,23.145,202.491,69.427,263.43 c46.282,60.94,111.853,91.41,196.705,91.41c88.447,0,155.558-29.698,201.333-89.096 c45.764-59.397,68.655-147.974,68.655-265.744C2662.975,2063.131,2639.7,1976.084,2593.162,1915.145z M2394.529,2372.194 c-25.722,0-44.356-16.066-55.927-48.212c-11.569-32.132-17.356-80.863-17.356-146.179c0-65.302,5.786-113.779,17.356-145.406 c11.571-31.628,30.205-47.44,55.927-47.44c49.368,0,74.053,64.29,74.053,192.847 C2468.582,2307.397,2443.897,2372.194,2394.529,2372.194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2383.26,1401.194c-4.411-7.489-12.454-12.421-21.145-12.421H2247.74 c-17.952,0-34.492,10.073-43.2,25.772l-591.272,1066.064c-4.216,7.6-4.097,17.116,0.313,24.606 c4.409,7.489,12.452,12.34,21.143,12.34h129.016c8.915,0,17.131-5.007,21.456-12.804l598.378-1078.953 C2387.789,1418.198,2387.669,1408.683,2383.26,1401.194z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155140845849536633190000010203745307675765652_",
    gradientUnits: "userSpaceOnUse",
    x1: 883.4621,
    y1: 1978.7526,
    x2: 2654.8113,
    y2: 1978.7526
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000155140845849536633190000010203745307675765652_)"
    },
    d: "M1551.673,1481.66 c-37.125-120.998-35.419-304.77,145.605-576.284c-466.994,134.529-813.816,558.009-813.816,1064.583 c0,626.15,526.976,1109.655,1154.759,1080.957c231.48-10.582,443.409-89.595,616.59-214.963 c-5.365-166.989-41.696-349.779-143.861-518.38C2230.034,1853.983,1668.151,1861.282,1551.673,1481.66z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000000912636291498503610000016783226770966720411_",
    d: "M1849.594,426.699 c-1051.703,0-1170.712,898.381-1170.712,898.381H377.243v81.636l592.96,815.497l724.541-946.672h-285.376l403.84-473.384 c0,0,464.105,82.93,624.292,136.728c207.014,76.316,369.811,249.518,369.811,249.518S2645.638,426.699,1849.594,426.699z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000049194002139065429150000014131583130137684393_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000000912636291498503610000016783226770966720411_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000049194002139065429150000014131583130137684393_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021087802489069254620000000790577581012882620_",
    gradientUnits: "userSpaceOnUse",
    x1: 1086.7512,
    y1: 2071.6104,
    x2: 2224.0095,
    y2: 512.9946
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB148"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0521,
    style: {
      stopColor: "#FDBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#F99C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    style: {
      stopColor: "#F8924F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8924F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021087802489069254620000000790577581012882620_)"
    },
    d: "M2785.088,1347.013v3.414 c-31.378-40.803-87.591-97.484-121.254-130.306c-0.628-1.451-1.683-2.903-2.309-4.354 c-18.782-42.895-44.12-89.333-77.201-135.685c-32.858-46.48-74.619-92.235-123.3-134.361 c-5.829-5.463-12.565-10.286-18.797-15.451c-3.182-2.518-6.394-5.122-9.623-7.64l-4.721-3.841 c-1.659-1.281-3.369-2.433-5.028-3.671c-6.678-4.823-13.362-9.689-20.086-14.597l-5.023-3.67l-5.289-3.415 c-3.498-2.305-6.994-4.61-10.491-6.872c-13.804-9.518-28.688-17.755-43.211-26.462c-7.396-4.225-15.153-8.109-22.683-12.121 c-3.721-2.006-7.531-4.055-11.342-6.018c-3.9-1.835-7.845-3.713-11.699-5.549c-62.218-29.92-130.085-51.559-199.699-63.467 c-8.696-1.366-17.394-2.732-26.18-4.098c-8.74-1.152-17.615-1.878-26.314-2.86l-13.176-1.408l-13.225-0.683l-13.224-0.768 c-4.393-0.214-8.74-0.64-13.179-0.555c-8.786-0.043-17.571-0.128-26.403-0.17c-2.151,0-4.483-0.128-6.498,0l-5.873,0.299 l-11.745,0.598l-11.655,0.554c-1.031,0.043-1.747,0.043-3.093,0.128l-11.968,0.854l-16.002,1.067l-11.97,0.853l-2.016,0.128 l-0.718,0.043c0,0.043-4.167,0,2.826,0.128l-25.867,3.628c-4.257,0.64-8.56,1.024-12.82,1.921l-12.684,2.433l-12.686,2.39 l-6.321,1.195c-2.108,0.384-4.17,0.982-6.231,1.451c-8.293,2.006-16.584,3.97-24.834,6.018 c-4.167,0.854-8.201,2.219-12.237,3.371l-12.102,3.628l-12.104,3.457l-11.835,4.14c-7.888,2.817-15.779,5.293-23.444,8.28 c-7.619,3.073-15.284,6.146-22.862,9.261c-60.29,25.524-114.486,58.517-160.61,96.204l-8.696,6.915l-8.25,7.384 c-5.467,4.865-11.117,9.518-16.317,14.511c-0.223,0.171-0.403,0.427-0.626,0.598c-10.132,9.987-20.397,19.378-29.496,29.707 c-2.421,2.518-4.798,5.079-7.127,7.64l-3.587,3.756l-3.316,4.012c-4.439,5.208-8.832,10.457-13.225,15.622 c-1.077,1.28-2.241,2.518-3.318,3.841l-3.003,4.012c-2.062,2.689-4.078,5.378-6.096,7.982 c-3.944,5.378-8.247,10.329-11.789,15.877c-29.945,42.681-52.76,85.363-68.27,126.081 c-15.645,40.633-24.924,78.747-30.258,112.423c-0.582,4.225-1.167,8.365-1.749,12.463c-0.493,4.054-1.344,8.024-1.523,11.993 c-0.672,7.939-1.346,15.493-2.018,22.706c-0.449,7.342-0.449,14.384-0.762,21c-0.134,3.329-0.359,6.573-0.403,9.689 c0.134,3.201,0.223,6.317,0.269,9.305c0.088,6.018,0.18,11.695,0.267,16.987c-0.044,1.494,0.225,2.262,0.315,3.286 c0.134,0.982,0.269,1.963,0.403,2.902c0.18,1.878,0.449,1.622,0.628,3.329c0.133,1.451,0.313,2.134,0.449,2.134h295.091 l-179.305,189.292l-416.839,434.071L411.545,1390.59h313.47c0.449,0,0.941-5.121,1.434-9.134 c1.21-8.664,2.51-17.115,3.944-27.402c0.808-5.122,1.523-9.902,2.377-15.408c0.446-2.689,0.851-5.25,1.3-8.067 c0.403-2.774,0.805-5.762,1.388-8.194c2.198-10.329,4.483-21.213,6.903-32.822c1.3-5.762,2.557-11.652,3.9-17.713 c1.436-6.06,3.139-12.206,4.841-18.524c3.406-12.591,6.724-25.822,10.848-39.438c4.393-13.53,8.965-27.572,13.671-42.169 c2.287-7.341,5.29-14.554,8.07-22.023c2.824-7.342,5.737-14.896,8.696-22.579c24.341-60.821,57.556-127.063,101.979-193.646 c44.244-66.625,100.59-132.995,167.47-194.541c8.114-7.896,17.079-15.109,25.731-22.664c4.393-3.713,8.74-7.469,13.135-11.225 l6.678-5.634l6.814-5.378c9.188-7.128,18.469-14.341,27.703-21.554l6.993-5.378l7.26-5.121 c4.888-3.458,9.729-6.872,14.614-10.286c19.141-13.957,39.715-26.548,60.156-39.523c10.309-6.317,20.977-12.207,31.602-18.31 c5.244-2.988,10.581-5.976,15.915-9.049c5.468-2.817,10.937-5.634,16.405-8.451c87.231-45.498,183.608-80.028,283.661-100.685 c12.507-2.348,25.103-4.738,37.654-7.085c12.553-2.22,25.326-3.756,37.969-5.592l19.005-2.56l19.141-1.793l19.095-1.75 c6.367-0.555,12.686-1.238,19.097-1.452c12.73-0.554,25.506-2.006,38.282-2.56c3.136-0.128,6.365-1.281,9.547-1.281h9.594 l19.051,1.024l19.051,0.598c6.365,0,12.73,0.811,19.051,1.11l37.879,2.176c8.606,0.128,2.957,0.214,5.155,0.256l0.985,0.128 l2.018,0.214l3.944,0.512l7.978,0.939l15.869,1.878l7.98,0.939l3.944,0.469l4.885,0.641l20.084,2.817l20.08,2.902l9.952,1.494 c3.272,0.512,6.185,1.195,9.324,1.792c12.237,2.476,24.475,4.994,36.712,7.426c6.096,1.152,12.104,2.818,18.11,4.311 l18.066,4.567l17.93,4.567l17.705,5.335c11.745,3.627,23.534,7.042,35.053,10.969c11.522,4.097,22.951,8.195,34.381,12.292 c90.685,34.316,173.434,80.113,244.574,133.422c4.483,3.287,8.919,6.616,13.356,9.902c4.349,3.415,8.608,6.872,12.866,10.372 c8.519,6.914,17.079,13.572,25.282,20.658c16.182,14.469,32.32,28.341,47.067,43.365c3.765,3.671,7.442,7.384,11.207,11.012 l5.514,5.463l5.29,5.676c7.037,7.597,13.984,15.152,20.844,22.621l5.155,5.634l4.931,5.804 c3.183,3.884,6.455,7.726,9.637,11.567c6.365,7.725,13.045,15.066,18.782,23.048c32.499,41.785,60.023,84.125,82.795,125.868 c11.117,20.274,21.023,40.462,29.765,60.394c27.029,60.864,44.377,118.783,55.315,170.385c1.21,6.488,2.51,12.847,3.721,19.121 c1.165,6.232,2.554,12.335,3.316,18.438c1.703,12.165,3.408,23.817,4.975,35.042c1.346,11.268,2.062,22.109,3.049,32.395 c0.403,5.122,0.941,10.116,1.254,15.067c0.179,4.866,1.256,9.646,1.479,14.341 C2783.519,1329.855,2785.088,1338.775,2785.088,1347.013z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000048476983597707066850000008889526259204544937_",
    gradientUnits: "userSpaceOnUse",
    x1: 2010.9781,
    y1: 1322.234,
    x2: 2431.3809,
    y2: 746.0709
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB148"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0521,
    style: {
      stopColor: "#FDBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#F99C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    style: {
      stopColor: "#F8924F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8924F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "url(#SVGID_00000048476983597707066850000008889526259204544937_)"
    },
    d: "M2785.088,1347.013v3.414 c-31.378-40.803-87.591-97.484-121.254-130.306c-0.628-1.451-1.683-2.903-2.309-4.354 c-18.782-42.895-44.12-89.333-77.201-135.685c-32.858-46.48-74.619-92.235-123.3-134.361 c-5.829-5.463-12.565-10.286-18.797-15.451c-3.182-2.518-6.394-5.122-9.623-7.64l-4.721-3.841 c-1.659-1.281-3.369-2.433-5.028-3.671c-6.678-4.823-13.362-9.689-20.086-14.597l-5.023-3.67l-5.289-3.415 c-3.498-2.305-6.994-4.61-10.491-6.872c-13.804-9.518-28.688-17.755-43.211-26.462c-7.396-4.225-15.153-8.109-22.683-12.121 c-3.721-2.006-7.531-4.055-11.342-6.018c-3.9-1.835-7.845-3.713-11.699-5.549c-62.218-29.92-130.085-51.559-199.699-63.467 c-8.696-1.366-17.394-2.732-26.18-4.098c-8.74-1.152-17.615-1.878-26.314-2.86l-13.176-1.408l-13.225-0.683l-13.224-0.768 c-4.393-0.214-8.74-0.64-13.179-0.555c-8.786-0.043-17.571-0.128-26.403-0.17c-2.151,0-4.483-0.128-6.498,0l-5.873,0.299 l-11.745,0.598l-11.655,0.554c-1.031,0.043-1.747,0.043-3.093,0.128l-11.968,0.854l-16.002,1.067l-11.97,0.853l-2.016,0.128 l-0.718,0.043c0,0.043-4.167,0,2.826,0.128l-25.867,3.628c-4.257,0.64-8.56,1.024-12.82,1.921l-12.684,2.433l-12.686,2.39 l-6.321,1.195c-2.108,0.384-4.17,0.982-6.231,1.451c-8.293,2.006-16.584,3.97-24.834,6.018 c-4.167,0.854-8.201,2.219-12.237,3.371l-12.102,3.628l-12.104,3.457l-11.835,4.14c-7.888,2.817-15.779,5.293-23.444,8.28 c-7.619,3.073-15.284,6.146-22.862,9.261c-60.29,25.524-114.486,58.517-160.61,96.204l-8.696,6.915l-8.25,7.384 c-5.467,4.865-11.117,9.518-16.317,14.511c-0.223,0.171-0.403,0.427-0.626,0.598 c132.46-156.171,347.044-257.625,589.195-257.625c248.113,0,467.266,106.49,598.788,269.15 c11.117,20.274,21.023,40.462,29.765,60.394c27.029,60.864,44.377,118.783,55.315,170.385c1.21,6.488,2.51,12.847,3.721,19.121 c1.165,6.232,2.554,12.335,3.316,18.438c1.703,12.165,3.408,23.817,4.975,35.042c1.346,11.268,2.062,22.109,3.049,32.395 c0.403,5.122,0.941,10.116,1.254,15.067c0.179,4.866,1.256,9.646,1.479,14.341 C2783.519,1329.855,2785.088,1338.775,2785.088,1347.013z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008858500379609557670000002879416550509560211_",
    gradientUnits: "userSpaceOnUse",
    x1: 522.4024,
    y1: 3213.3059,
    x2: 1467.7875,
    y2: 3213.3059
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB148"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0521,
    style: {
      stopColor: "#FDBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#F99C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    style: {
      stopColor: "#F8924F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8924F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008858500379609557670000002879416550509560211_)"
    },
    d: "M592.653,3141.078v91.135 c0,29.449,183.957,53.321,410.88,53.321s410.88-23.872,410.88-53.321v-91.135H592.653z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000123400572768486326230000005794793976574783923_",
    gradientUnits: "userSpaceOnUse",
    x1: 999.4396,
    y1: 3106.8118,
    x2: 1049.2793,
    y2: 3524.0422
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDB44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEEF06"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000123400572768486326230000005794793976574783923_)"
    },
    d: "M1414.412,3141.077 c0,29.449-183.957,53.321-410.88,53.321s-410.88-23.873-410.88-53.321c0-29.448,183.957-53.32,410.88-53.32 S1414.412,3111.629,1414.412,3141.077z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000146467723083576328730000013299859847942950059_",
    gradientUnits: "userSpaceOnUse",
    x1: 997.2725,
    y1: 3088.2051,
    x2: 1012.579,
    y2: 3216.3438
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDB44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEEF06"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000146467723083576328730000013299859847942950059_)"
    },
    d: "M1003.531,3198.076 c-200.968,0-411.117-19.196-411.117-56.219c0-2.033,0.725-5.607,2.759-5.607c2.034,0,1.159,2.796,1.159,4.828 c0,23.48,167.232,49.64,407.2,49.64c239.969,0,407.201-26.16,407.201-49.64c0-2.033,0.347-3.938,2.38-3.938 s1.542,2.713,1.542,4.747C1414.655,3178.91,1204.5,3198.076,1003.531,3198.076z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCB048"
    },
    d: "M964.706,3144.049c4.032-2.79,8.322-5.541,12.914-8.26c4.548-2.714,10.474-5.167,17.651-7.358 c7.219-2.192,16.247-3.974,27.085-5.357c10.838-1.382,24.39-2.111,40.571-2.19c15.879-0.077,30.772,0.427,44.721,1.513 c13.905,1.083,26.178,2.709,36.775,4.869c10.554,2.161,19.174,4.834,25.817,8.009c6.6,3.186,10.533,6.83,11.802,10.938 l46.264,0.468c3.357,0.022,6.328,0.293,8.87,0.822c2.584,0.527,3.836,1.193,3.84,2l0.019,3.81l-59.476-0.573 c-2.087,4.666-7.401,8.933-15.947,12.803c-8.502,3.876-19.373,7.226-32.614,10.062l-21.661-3.012 c-1.938-0.296-3.533-0.674-4.783-1.133c-1.25-0.454-1.855-0.948-1.857-1.489c-0.004-0.732,1.67-1.567,5.023-2.505 c3.352-0.941,7.133-2.106,11.343-3.493c4.211-1.382,8.335-3.02,12.413-4.909c4.036-1.884,6.737-4.138,8.143-6.762 l-140.385-1.391c-3.688,2.714-7.848,5.378-12.398,7.999c-4.592,2.619-10.649,4.98-18.212,7.074 c-7.564,2.096-16.98,3.794-28.248,5.105c-11.313,1.305-25.467,1.998-42.594,2.083c-12.868,0.062-25.392-0.426-37.662-1.459 c-12.27-1.039-23.165-2.592-32.685-4.659c-9.521-2.071-17.323-4.631-23.449-7.677c-6.083-3.052-9.5-6.553-10.208-10.515 l-38.087-0.391c-3.357-0.021-6.328-0.283-8.998-0.791c-2.628-0.509-3.966-1.183-3.969-2.029l-0.019-3.809l52.074,0.496 c2.305-4.013,7.021-7.513,14.236-10.488c7.215-2.98,16.024-5.631,26.427-7.951l17.44,2.395 c5.297,0.744,7.927,1.613,7.932,2.615c0.002,0.54-1.07,1.208-3.261,2.008c-2.234,0.8-4.812,1.757-7.819,2.866 c-2.964,1.114-5.884,2.415-8.674,3.914c-2.834,1.494-4.934,3.185-6.344,5.08L964.706,3144.049z M836.23,3149.24 c1.047,2.499,3.38,4.648,6.918,6.458c3.537,1.815,7.935,3.301,13.233,4.468c5.299,1.168,11.242,2.022,17.829,2.566 c6.63,0.545,13.56,0.803,20.79,0.767c8.434-0.041,15.792-0.406,22.071-1.091c6.237-0.688,11.74-1.617,16.511-2.796 c4.729-1.179,8.896-2.542,12.418-4.1c3.521-1.559,6.654-3.246,9.485-5.068L836.23,3149.24z M1141.845,3145.834 c-1.045-2.531-3.596-4.75-7.563-6.656c-3.969-1.902-9.056-3.507-15.215-4.802c-6.161-1.299-13.352-2.264-21.575-2.896 c-8.18-0.632-17.218-0.926-27.115-0.876c-8.779,0.042-16.394,0.437-22.716,1.178c-6.323,0.745-11.826,1.738-16.51,2.997 c-4.642,1.254-8.638,2.715-11.856,4.384c-3.263,1.67-6.31,3.456-9.098,5.358L1141.845,3145.834z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005954796849514217360000002941915611092971413_",
    gradientUnits: "userSpaceOnUse",
    x1: 657.5875,
    y1: 924.929,
    x2: 672.8398,
    y2: 1052.6132,
    gradientTransform: "matrix(-1 0 0 -1 1669.249 4127.8389)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#F36F56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3059,
    style: {
      stopColor: "#F99C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6817,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8038,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8667,
    style: {
      stopColor: "#FEBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    style: {
      stopColor: "#FCAD49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958,
    style: {
      stopColor: "#F99A4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9955,
    style: {
      stopColor: "#F58152"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F57E53"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005954796849514217360000002941915611092971413_)"
    },
    d: "M1003.589,3093.529 c-183.204,0-373.961,16.12-404.472,47.328c1.194,1.101,2.304,2.275,3.335,3.511c25.718-21.668,183.229-43.483,401.137-43.483 c223.502,0,383.538,22.953,402.923,45.155c0.953-1.218,1.972-2.384,3.073-3.482 C1384.383,3110.245,1190.047,3093.529,1003.589,3093.529z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000022538456989965541200000017605214364925989774_",
    gradientUnits: "userSpaceOnUse",
    x1: 408.1807,
    y1: 3117.5793,
    x2: 1353.5647,
    y2: 3117.5793
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB148"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0521,
    style: {
      stopColor: "#FDBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#F99C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    style: {
      stopColor: "#F8924F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8924F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000022538456989965541200000017605214364925989774_)"
    },
    d: "M478.431,3045.351v91.135 c0,29.45,183.957,53.321,410.88,53.321c226.922,0,410.879-23.872,410.879-53.321v-91.135H478.431z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000154419027945970841050000006565753672846687109_",
    gradientUnits: "userSpaceOnUse",
    x1: 885.2174,
    y1: 3011.0859,
    x2: 935.057,
    y2: 3428.3162
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDB44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEEF06"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000154419027945970841050000006565753672846687109_)"
    },
    d: "M1300.19,3045.351 c0,29.448-183.957,53.321-410.879,53.321c-226.923,0-410.88-23.873-410.88-53.321c0-29.448,183.957-53.321,410.88-53.321 C1116.233,2992.031,1300.19,3015.903,1300.19,3045.351z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042008007895850306090000016814196284006754177_",
    gradientUnits: "userSpaceOnUse",
    x1: 883.0504,
    y1: 2992.4792,
    x2: 898.3569,
    y2: 3120.6172
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDB44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEEF06"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000042008007895850306090000016814196284006754177_)"
    },
    d: "M889.309,3102.349 c-200.968,0-411.117-19.195-411.117-56.219c0-2.034,0.725-5.607,2.758-5.607c2.034,0,1.159,2.795,1.159,4.828 c0,23.481,167.232,49.641,407.2,49.641s407.2-26.16,407.2-49.641c0-2.033,0.347-3.938,2.38-3.938 c2.034,0,1.543,2.713,1.543,4.747C1300.433,3083.184,1090.278,3102.349,889.309,3102.349z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCB048"
    },
    d: "M850.484,3048.324c4.031-2.791,8.322-5.542,12.913-8.26c4.548-2.715,10.475-5.167,17.651-7.359 c7.219-2.191,16.248-3.974,27.086-5.356c10.838-1.382,24.39-2.111,40.57-2.191c15.88-0.077,30.772,0.427,44.721,1.513 c13.906,1.083,26.179,2.709,36.775,4.87c10.555,2.16,19.174,4.834,25.817,8.009c6.6,3.186,10.534,6.83,11.802,10.939 l46.264,0.468c3.357,0.021,6.328,0.292,8.87,0.821c2.585,0.527,3.836,1.193,3.84,2.001l0.019,3.809l-59.476-0.572 c-2.086,4.666-7.401,8.933-15.947,12.804c-8.502,3.875-19.372,7.225-32.613,10.061l-21.661-3.013 c-1.938-0.296-3.533-0.672-4.783-1.132c-1.251-0.455-1.856-0.949-1.858-1.489c-0.004-0.733,1.672-1.568,5.023-2.504 c3.353-0.942,7.134-2.107,11.344-3.494c4.21-1.383,8.334-3.019,12.412-4.909c4.037-1.885,6.737-4.138,8.143-6.762 l-140.384-1.392c-3.688,2.714-7.849,5.379-12.399,8c-4.592,2.619-10.647,4.979-18.211,7.075 c-7.564,2.094-16.981,3.793-28.249,5.103c-11.311,1.305-25.466,1.999-42.594,2.083c-12.867,0.063-25.393-0.425-37.663-1.459 c-12.269-1.038-23.164-2.592-32.685-4.658c-9.52-2.071-17.323-4.631-23.448-7.678c-6.083-3.051-9.5-6.552-10.208-10.514 l-38.088-0.391c-3.356-0.021-6.328-0.283-8.998-0.792c-2.628-0.508-3.965-1.183-3.969-2.028l-0.019-3.809l52.075,0.496 c2.304-4.013,7.021-7.512,14.236-10.488c7.215-2.981,16.024-5.631,26.427-7.95l17.44,2.394 c5.296,0.744,7.926,1.615,7.931,2.614c0.003,0.541-1.07,1.208-3.261,2.009c-2.233,0.799-4.81,1.756-7.819,2.866 c-2.964,1.114-5.883,2.415-8.674,3.913c-2.833,1.494-4.933,3.185-6.344,5.081L850.484,3048.324z M722.008,3053.515 c1.046,2.498,3.38,4.648,6.917,6.457c3.538,1.814,7.935,3.301,13.234,4.468c5.299,1.167,11.242,2.021,17.829,2.567 c6.63,0.544,13.56,0.802,20.789,0.767c8.435-0.042,15.792-0.407,22.071-1.091c6.237-0.688,11.741-1.617,16.513-2.795 c4.728-1.179,8.895-2.544,12.416-4.102c3.521-1.558,6.654-3.246,9.487-5.068L722.008,3053.515z M1027.623,3050.109 c-1.046-2.532-3.596-4.75-7.564-6.656c-3.969-1.902-9.054-3.507-15.215-4.802c-6.159-1.299-13.352-2.264-21.573-2.895 c-8.18-0.633-17.219-0.926-27.116-0.877c-8.78,0.043-16.394,0.438-22.717,1.178c-6.322,0.745-11.826,1.74-16.51,2.998 c-4.641,1.252-8.637,2.715-11.856,4.385c-3.263,1.669-6.31,3.455-9.096,5.357L1027.623,3050.109z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135685417295560304920000007979646853714863006_",
    gradientUnits: "userSpaceOnUse",
    x1: 771.8102,
    y1: 1020.6555,
    x2: 787.0625,
    y2: 1148.3395,
    gradientTransform: "matrix(-1 0 0 -1 1669.249 4127.8389)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#F36F56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3059,
    style: {
      stopColor: "#F99C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6817,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8038,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8667,
    style: {
      stopColor: "#FEBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    style: {
      stopColor: "#FCAD49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958,
    style: {
      stopColor: "#F99A4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9955,
    style: {
      stopColor: "#F58152"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F57E53"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000135685417295560304920000007979646853714863006_)"
    },
    d: "M889.366,2997.802 c-183.204,0-373.96,16.121-404.472,47.328c1.194,1.101,2.304,2.276,3.335,3.512c25.719-21.669,183.23-43.484,401.137-43.484 c223.502,0,383.538,22.952,402.924,45.154c0.952-1.217,1.971-2.384,3.072-3.481 C1270.161,3014.519,1075.824,2997.802,889.366,2997.802z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005981982577312500550000015259125086122685860_",
    gradientUnits: "userSpaceOnUse",
    x1: 506.7382,
    y1: 3022.1333,
    x2: 1452.1232,
    y2: 3022.1333
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB148"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0521,
    style: {
      stopColor: "#FDBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#F99C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    style: {
      stopColor: "#F8924F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8924F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005981982577312500550000015259125086122685860_)"
    },
    d: "M576.989,2949.905v91.135 c0,29.45,183.958,53.321,410.881,53.321c226.922,0,410.879-23.872,410.879-53.321v-91.135H576.989z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000149352505246275839920000015945134043438279341_",
    gradientUnits: "userSpaceOnUse",
    x1: 983.7755,
    y1: 2915.6401,
    x2: 1033.6151,
    y2: 3332.8704
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDB44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEEF06"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000149352505246275839920000015945134043438279341_)"
    },
    d: "M1398.748,2949.905 c0,29.449-183.957,53.321-410.879,53.321c-226.923,0-410.881-23.873-410.881-53.321c0-29.448,183.958-53.32,410.881-53.32 C1214.791,2896.585,1398.748,2920.458,1398.748,2949.905z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003821824418453647100000014725669298827943567_",
    gradientUnits: "userSpaceOnUse",
    x1: 981.6088,
    y1: 2897.0334,
    x2: 996.9153,
    y2: 3025.1711
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDB44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEEF06"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003821824418453647100000014725669298827943567_)"
    },
    d: "M987.868,3006.903 c-200.968,0-411.117-19.194-411.117-56.219c0-2.034,0.725-5.607,2.758-5.607c2.034,0,1.159,2.795,1.159,4.828 c0,23.481,167.232,49.641,407.2,49.641s407.2-26.16,407.2-49.641c0-2.033,0.347-3.938,2.38-3.938 c2.034,0,1.543,2.713,1.543,4.747C1398.991,2987.738,1188.837,3006.903,987.868,3006.903z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCB048"
    },
    d: "M949.043,2952.877c4.031-2.791,8.321-5.541,12.913-8.26c4.549-2.715,10.474-5.167,17.651-7.359 c7.219-2.191,16.247-3.974,27.086-5.356c10.838-1.382,24.389-2.111,40.57-2.191c15.88-0.077,30.772,0.427,44.721,1.514 c13.905,1.083,26.179,2.709,36.775,4.869c10.555,2.161,19.175,4.834,25.818,8.009c6.599,3.186,10.533,6.83,11.801,10.939 l46.264,0.468c3.357,0.021,6.328,0.293,8.87,0.821c2.585,0.527,3.836,1.193,3.84,2.001l0.019,3.809l-59.476-0.573 c-2.086,4.666-7.401,8.933-15.947,12.804c-8.502,3.875-19.372,7.225-32.613,10.061l-21.662-3.012 c-1.937-0.295-3.532-0.672-4.782-1.132c-1.251-0.454-1.855-0.949-1.858-1.489c-0.004-0.733,1.671-1.567,5.023-2.504 c3.353-0.942,7.133-2.107,11.344-3.494c4.21-1.383,8.334-3.019,12.412-4.908c4.037-1.885,6.737-4.138,8.143-6.762 l-140.385-1.392c-3.688,2.714-7.848,5.379-12.398,8c-4.591,2.619-10.648,4.979-18.211,7.074 c-7.564,2.094-16.981,3.794-28.249,5.103c-11.312,1.305-25.467,1.998-42.593,2.083c-12.868,0.063-25.393-0.425-37.663-1.459 c-12.269-1.038-23.165-2.592-32.686-4.658c-9.52-2.072-17.323-4.632-23.448-7.678c-6.083-3.051-9.5-6.553-10.209-10.514 l-38.087-0.391c-3.357-0.021-6.328-0.283-8.998-0.792c-2.628-0.508-3.966-1.182-3.969-2.028l-0.019-3.809l52.075,0.496 c2.304-4.013,7.02-7.513,14.236-10.489c7.214-2.981,16.024-5.631,26.426-7.95l17.441,2.395 c5.296,0.744,7.926,1.614,7.931,2.614c0.002,0.541-1.07,1.208-3.261,2.008c-2.234,0.8-4.811,1.757-7.819,2.866 c-2.964,1.114-5.883,2.415-8.674,3.913c-2.833,1.494-4.933,3.186-6.344,5.081L949.043,2952.877z M820.567,2958.069 c1.046,2.498,3.38,4.648,6.918,6.457c3.536,1.814,7.934,3.301,13.233,4.468c5.299,1.167,11.242,2.021,17.828,2.567 c6.631,0.544,13.56,0.802,20.79,0.767c8.434-0.042,15.792-0.407,22.071-1.091c6.237-0.688,11.74-1.617,16.512-2.795 c4.729-1.179,8.896-2.544,12.417-4.101c3.521-1.559,6.654-3.246,9.485-5.068L820.567,2958.069z M1126.181,2954.663 c-1.045-2.532-3.595-4.75-7.563-6.656c-3.969-1.902-9.055-3.508-15.215-4.802c-6.16-1.299-13.352-2.265-21.574-2.896 c-8.18-0.632-17.219-0.926-27.115-0.877c-8.78,0.043-16.395,0.438-22.717,1.178c-6.322,0.745-11.825,1.739-16.51,2.998 c-4.641,1.253-8.637,2.715-11.856,4.385c-3.263,1.669-6.31,3.454-9.097,5.357L1126.181,2954.663z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088127588532048320980000010125809095559459730_",
    gradientUnits: "userSpaceOnUse",
    x1: 673.2517,
    y1: 1116.1014,
    x2: 688.504,
    y2: 1243.7854,
    gradientTransform: "matrix(-1 0 0 -1 1669.249 4127.8389)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#F36F56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3059,
    style: {
      stopColor: "#F99C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6817,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8038,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8667,
    style: {
      stopColor: "#FEBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    style: {
      stopColor: "#FCAD49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958,
    style: {
      stopColor: "#F99A4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9955,
    style: {
      stopColor: "#F58152"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F57E53"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088127588532048320980000010125809095559459730_)"
    },
    d: "M987.924,2902.356 c-183.204,0-373.96,16.12-404.472,47.328c1.194,1.101,2.304,2.276,3.335,3.512c25.718-21.669,183.23-43.483,401.137-43.483 c223.502,0,383.538,22.952,402.924,45.154c0.952-1.218,1.97-2.384,3.072-3.481 C1368.719,2919.073,1174.383,2902.356,987.924,2902.356z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054982366950574624190000009933089036395966646_",
    gradientUnits: "userSpaceOnUse",
    x1: 566.5474,
    y1: 2926.408,
    x2: 1511.9313,
    y2: 2926.408
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB148"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0521,
    style: {
      stopColor: "#FDBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#F99C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    style: {
      stopColor: "#F8924F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8924F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054982366950574624190000009933089036395966646_)"
    },
    d: "M636.798,2854.18v91.134 c0,29.45,183.956,53.321,410.879,53.321c226.922,0,410.88-23.872,410.88-53.321v-91.134H636.798z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000113344762814176098750000015974659867388484242_",
    gradientUnits: "userSpaceOnUse",
    x1: 1043.584,
    y1: 2819.9138,
    x2: 1093.4236,
    y2: 3237.1445
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDB44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEEF06"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000113344762814176098750000015974659867388484242_)"
    },
    cx: 1047.677,
    cy: 2854.179,
    rx: 410.879,
    ry: 53.321
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000094591520877489285130000012604371938321395083_",
    gradientUnits: "userSpaceOnUse",
    x1: 1041.4163,
    y1: 2801.3066,
    x2: 1056.7229,
    y2: 2929.4453
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDB44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEEF06"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000094591520877489285130000012604371938321395083_)"
    },
    d: "M1047.675,2911.177 c-200.968,0-411.117-19.195-411.117-56.219c0-2.034,0.725-5.608,2.759-5.608c2.034,0,1.159,2.796,1.159,4.829 c0,23.479,167.232,49.639,407.2,49.639c239.969,0,407.201-26.16,407.201-49.639c0-2.034,0.347-3.939,2.38-3.939 s1.542,2.713,1.542,4.747C1458.798,2892.012,1248.644,2911.177,1047.675,2911.177z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCB048"
    },
    d: "M1008.85,2857.152c4.031-2.791,8.322-5.542,12.913-8.26c4.549-2.713,10.476-5.167,17.651-7.358 c7.219-2.192,16.248-3.974,27.086-5.356c10.838-1.382,24.391-2.111,40.571-2.191c15.879-0.077,30.772,0.427,44.721,1.514 c13.906,1.083,26.178,2.709,36.775,4.869c10.554,2.161,19.173,4.834,25.817,8.01c6.6,3.185,10.533,6.83,11.802,10.938 l46.264,0.468c3.357,0.022,6.328,0.293,8.87,0.822c2.584,0.527,3.836,1.193,3.84,2l0.019,3.81l-59.477-0.572 c-2.086,4.666-7.401,8.934-15.946,12.804c-8.502,3.874-19.373,7.225-32.613,10.062l-21.661-3.014 c-1.938-0.296-3.533-0.673-4.783-1.132c-1.25-0.454-1.855-0.949-1.857-1.489c-0.004-0.732,1.671-1.567,5.023-2.504 c3.352-0.943,7.134-2.107,11.343-3.495c4.211-1.382,8.334-3.018,12.413-4.909c4.036-1.884,6.737-4.138,8.143-6.761 l-140.384-1.392c-3.688,2.714-7.849,5.379-12.399,7.999c-4.592,2.621-10.648,4.98-18.212,7.075 c-7.564,2.095-16.98,3.794-28.248,5.104c-11.312,1.305-25.466,1.999-42.594,2.083c-12.867,0.063-25.392-0.426-37.662-1.459 c-12.27-1.039-23.164-2.592-32.686-4.658c-9.52-2.072-17.322-4.631-23.448-7.678c-6.083-3.052-9.5-6.553-10.208-10.515 l-38.088-0.39c-3.356-0.022-6.327-0.283-8.997-0.792c-2.628-0.508-3.965-1.183-3.969-2.029l-0.018-3.809l52.073,0.496 c2.305-4.013,7.021-7.513,14.236-10.488c7.216-2.98,16.024-5.63,26.428-7.95l17.44,2.394c5.297,0.744,7.927,1.615,7.932,2.615 c0.003,0.54-1.071,1.208-3.261,2.008c-2.233,0.8-4.811,1.757-7.819,2.866c-2.964,1.114-5.884,2.416-8.674,3.913 c-2.833,1.494-4.933,3.185-6.343,5.08L1008.85,2857.152z M880.374,2862.343c1.046,2.498,3.38,4.647,6.918,6.457 c3.538,1.815,7.935,3.301,13.233,4.469c5.299,1.167,11.242,2.021,17.83,2.566c6.629,0.545,13.559,0.803,20.789,0.768 c8.435-0.042,15.791-0.407,22.071-1.091c6.237-0.688,11.741-1.617,16.512-2.796c4.728-1.179,8.896-2.543,12.417-4.101 c3.521-1.559,6.654-3.246,9.486-5.068L880.374,2862.343z M1185.989,2858.937c-1.046-2.531-3.596-4.75-7.564-6.657 c-3.968-1.901-9.054-3.507-15.214-4.801c-6.16-1.299-13.352-2.264-21.574-2.895c-8.18-0.632-17.218-0.926-27.116-0.877 c-8.779,0.043-16.393,0.437-22.716,1.178c-6.323,0.745-11.826,1.739-16.51,2.997c-4.642,1.253-8.637,2.715-11.856,4.385 c-3.263,1.669-6.31,3.455-9.097,5.358L1185.989,2858.937z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072999382655716422120000012300740492190985132_",
    gradientUnits: "userSpaceOnUse",
    x1: 613.4441,
    y1: 1211.8273,
    x2: 628.6964,
    y2: 1339.5112,
    gradientTransform: "matrix(-1 0 0 -1 1669.249 4127.8389)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#F36F56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3059,
    style: {
      stopColor: "#F99C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6817,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8038,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8667,
    style: {
      stopColor: "#FEBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    style: {
      stopColor: "#FCAD49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958,
    style: {
      stopColor: "#F99A4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9955,
    style: {
      stopColor: "#F58152"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F57E53"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072999382655716422120000012300740492190985132_)"
    },
    d: "M1047.733,2806.631 c-183.205,0-373.961,16.121-404.473,47.328c1.195,1.101,2.305,2.275,3.336,3.512c25.718-21.668,183.229-43.484,401.137-43.484 c223.503,0,383.537,22.953,402.923,45.154c0.953-1.218,1.972-2.384,3.073-3.48 C1428.527,2823.347,1234.191,2806.631,1047.733,2806.631z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008847265700944009660000015246514511331271861_",
    gradientUnits: "userSpaceOnUse",
    x1: 522.4024,
    y1: 2823.1299,
    x2: 1467.7875,
    y2: 2823.1299
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB148"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0521,
    style: {
      stopColor: "#FDBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#F99C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    style: {
      stopColor: "#F8924F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8924F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008847265700944009660000015246514511331271861_)"
    },
    d: "M592.653,2750.902v91.135 c0,29.449,183.957,53.32,410.88,53.32s410.88-23.872,410.88-53.32v-91.135H592.653z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000151537375214680462700000010623566209343256195_",
    gradientUnits: "userSpaceOnUse",
    x1: 999.4396,
    y1: 2716.6362,
    x2: 1049.2792,
    y2: 3133.8669
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDB44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEEF06"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000151537375214680462700000010623566209343256195_)"
    },
    d: "M1414.412,2750.902 c0,29.448-183.957,53.32-410.88,53.32s-410.88-23.873-410.88-53.32c0-29.449,183.957-53.321,410.88-53.321 S1414.412,2721.454,1414.412,2750.902z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101824064780381718330000008824798718750729892_",
    gradientUnits: "userSpaceOnUse",
    x1: 997.2723,
    y1: 2698.0286,
    x2: 1012.579,
    y2: 2826.1675
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDB44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEEF06"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101824064780381718330000008824798718750729892_)"
    },
    d: "M1003.531,2807.899 c-200.968,0-411.117-19.195-411.117-56.219c0-2.034,0.725-5.608,2.759-5.608c2.034,0,1.159,2.796,1.159,4.829 c0,23.479,167.232,49.64,407.2,49.64c239.969,0,407.201-26.161,407.201-49.64c0-2.034,0.347-3.939,2.38-3.939 s1.542,2.713,1.542,4.747C1414.655,2788.734,1204.5,2807.899,1003.531,2807.899z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCB048"
    },
    d: "M964.706,2753.874c4.032-2.791,8.322-5.541,12.914-8.26c4.548-2.714,10.474-5.167,17.651-7.359 c7.219-2.191,16.247-3.973,27.085-5.356c10.838-1.382,24.39-2.111,40.571-2.191c15.879-0.077,30.772,0.427,44.721,1.514 c13.905,1.083,26.178,2.708,36.775,4.869c10.554,2.16,19.174,4.833,25.817,8.009c6.6,3.185,10.533,6.83,11.802,10.938 l46.264,0.469c3.357,0.021,6.328,0.292,8.87,0.821c2.584,0.528,3.836,1.193,3.84,2.001l0.019,3.809l-59.476-0.572 c-2.087,4.666-7.401,8.934-15.947,12.804c-8.502,3.875-19.373,7.226-32.614,10.062l-21.661-3.013 c-1.938-0.296-3.533-0.673-4.783-1.132c-1.25-0.453-1.855-0.949-1.857-1.489c-0.004-0.733,1.67-1.568,5.023-2.504 c3.352-0.943,7.133-2.106,11.343-3.495c4.211-1.382,8.335-3.018,12.413-4.908c4.036-1.885,6.737-4.139,8.143-6.762 l-140.385-1.392c-3.688,2.714-7.848,5.379-12.398,8c-4.592,2.62-10.649,4.98-18.212,7.074 c-7.564,2.094-16.98,3.793-28.248,5.103c-11.313,1.305-25.467,2-42.594,2.083c-12.868,0.064-25.392-0.426-37.662-1.459 c-12.27-1.039-23.165-2.592-32.685-4.658c-9.521-2.072-17.323-4.631-23.449-7.678c-6.083-3.051-9.5-6.552-10.208-10.514 l-38.087-0.39c-3.357-0.023-6.328-0.284-8.998-0.793c-2.628-0.509-3.966-1.183-3.969-2.028l-0.019-3.809l52.074,0.496 c2.305-4.014,7.021-7.513,14.236-10.489c7.215-2.98,16.024-5.63,26.427-7.95l17.44,2.395c5.297,0.745,7.927,1.615,7.932,2.616 c0.002,0.54-1.07,1.208-3.261,2.007c-2.234,0.8-4.812,1.757-7.819,2.866c-2.964,1.114-5.884,2.416-8.674,3.914 c-2.834,1.493-4.934,3.185-6.344,5.081L964.706,2753.874z M836.23,2759.066c1.047,2.498,3.38,4.647,6.918,6.457 c3.537,1.815,7.935,3.302,13.233,4.468c5.299,1.167,11.242,2.021,17.829,2.567c6.63,0.544,13.56,0.802,20.79,0.767 c8.434-0.041,15.792-0.407,22.071-1.09c6.237-0.688,11.74-1.617,16.511-2.797c4.729-1.179,8.896-2.542,12.418-4.101 c3.521-1.558,6.654-3.246,9.485-5.068L836.23,2759.066z M1141.845,2755.659c-1.045-2.531-3.596-4.75-7.563-6.657 c-3.969-1.901-9.056-3.507-15.215-4.802c-6.161-1.299-13.352-2.264-21.575-2.895c-8.18-0.632-17.218-0.926-27.115-0.877 c-8.779,0.043-16.394,0.437-22.716,1.178c-6.323,0.745-11.826,1.74-16.51,2.997c-4.642,1.254-8.638,2.716-11.856,4.385 c-3.263,1.669-6.31,3.455-9.098,5.358L1141.845,2755.659z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029757540163723208710000000802499340411657910_",
    gradientUnits: "userSpaceOnUse",
    x1: 657.5875,
    y1: 1315.1053,
    x2: 672.8398,
    y2: 1442.7889,
    gradientTransform: "matrix(-1 0 0 -1 1669.249 4127.8389)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#F36F56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3059,
    style: {
      stopColor: "#F99C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6817,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8038,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8667,
    style: {
      stopColor: "#FEBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    style: {
      stopColor: "#FCAD49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958,
    style: {
      stopColor: "#F99A4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9955,
    style: {
      stopColor: "#F58152"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F57E53"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029757540163723208710000000802499340411657910_)"
    },
    d: "M1003.589,2703.353 c-183.204,0-373.961,16.121-404.472,47.328c1.194,1.101,2.304,2.277,3.335,3.512c25.718-21.668,183.229-43.483,401.137-43.483 c223.502,0,383.538,22.952,402.923,45.153c0.953-1.218,1.972-2.384,3.073-3.48 C1384.383,2720.07,1190.047,2703.353,1003.589,2703.353z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070803475347996309170000014302780098577317300_",
    gradientUnits: "userSpaceOnUse",
    x1: 408.1807,
    y1: 2727.4033,
    x2: 1353.5647,
    y2: 2727.4033
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB148"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0521,
    style: {
      stopColor: "#FDBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#F99C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    style: {
      stopColor: "#F8924F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8924F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070803475347996309170000014302780098577317300_)"
    },
    d: "M478.431,2655.176v91.136 c0,29.448,183.957,53.32,410.88,53.32c226.922,0,410.879-23.872,410.879-53.32v-91.136H478.431z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036953014366072459600000005224148506822216077_",
    gradientUnits: "userSpaceOnUse",
    x1: 885.2173,
    y1: 2620.9097,
    x2: 935.0571,
    y2: 3038.1414
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDB44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEEF06"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000036953014366072459600000005224148506822216077_)"
    },
    cx: 889.311,
    cy: 2655.176,
    rx: 410.88,
    ry: 53.321
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165944715727520831100000010809991299671849091_",
    gradientUnits: "userSpaceOnUse",
    x1: 883.0504,
    y1: 2602.3027,
    x2: 898.3571,
    y2: 2730.4414
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDB44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEEF06"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165944715727520831100000010809991299671849091_)"
    },
    d: "M889.309,2712.174 c-200.968,0-411.117-19.195-411.117-56.219c0-2.034,0.725-5.607,2.758-5.607c2.034,0,1.159,2.795,1.159,4.828 c0,23.48,167.232,49.641,407.2,49.641s407.2-26.161,407.2-49.641c0-2.033,0.347-3.938,2.38-3.938 c2.034,0,1.543,2.713,1.543,4.747C1300.433,2693.008,1090.278,2712.174,889.309,2712.174z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCB048"
    },
    d: "M850.484,2658.148c4.031-2.791,8.322-5.542,12.913-8.26c4.548-2.714,10.475-5.167,17.651-7.358 c7.219-2.191,16.248-3.974,27.086-5.357c10.838-1.382,24.39-2.111,40.57-2.189c15.88-0.079,30.772,0.426,44.721,1.513 c13.906,1.083,26.179,2.708,36.775,4.869c10.555,2.16,19.174,4.833,25.817,8.009c6.6,3.185,10.534,6.83,11.802,10.938 l46.264,0.469c3.357,0.021,6.328,0.293,8.87,0.821c2.585,0.527,3.836,1.193,3.84,2.001l0.019,3.809l-59.476-0.573 c-2.086,4.666-7.401,8.934-15.947,12.804c-8.502,3.875-19.372,7.226-32.613,10.062l-21.661-3.013 c-1.938-0.295-3.533-0.672-4.783-1.131c-1.251-0.455-1.856-0.949-1.858-1.489c-0.004-0.733,1.672-1.568,5.023-2.505 c3.353-0.942,7.134-2.107,11.344-3.494c4.21-1.383,8.334-3.019,12.412-4.909c4.037-1.885,6.737-4.138,8.143-6.761 l-140.384-1.393c-3.688,2.715-7.849,5.379-12.399,8c-4.592,2.62-10.647,4.98-18.211,7.074 c-7.564,2.095-16.981,3.794-28.249,5.103c-11.311,1.306-25.466,2-42.594,2.083c-12.867,0.064-25.393-0.425-37.663-1.459 c-12.269-1.039-23.164-2.592-32.685-4.659c-9.52-2.071-17.323-4.63-23.448-7.677c-6.083-3.051-9.5-6.553-10.208-10.514 l-38.088-0.391c-3.356-0.021-6.328-0.283-8.998-0.792c-2.628-0.509-3.965-1.183-3.969-2.028l-0.019-3.81l52.075,0.496 c2.304-4.013,7.021-7.512,14.236-10.489c7.215-2.98,16.024-5.631,26.427-7.95l17.44,2.394c5.296,0.744,7.926,1.615,7.931,2.615 c0.003,0.54-1.07,1.208-3.261,2.008c-2.233,0.801-4.81,1.757-7.819,2.867c-2.964,1.113-5.883,2.414-8.674,3.912 c-2.833,1.494-4.933,3.186-6.344,5.081L850.484,2658.148z M722.008,2663.339c1.046,2.499,3.38,4.648,6.917,6.457 c3.538,1.815,7.935,3.301,13.234,4.469c5.299,1.166,11.242,2.021,17.829,2.566c6.63,0.545,13.56,0.802,20.789,0.767 c8.435-0.041,15.792-0.406,22.071-1.09c6.237-0.688,11.741-1.617,16.513-2.796c4.728-1.179,8.895-2.543,12.416-4.101 c3.521-1.558,6.654-3.246,9.487-5.068L722.008,2663.339z M1027.623,2659.932c-1.046-2.531-3.596-4.749-7.564-6.656 c-3.969-1.902-9.054-3.508-15.215-4.801c-6.159-1.3-13.352-2.265-21.573-2.897c-8.18-0.631-17.219-0.925-27.116-0.876 c-8.78,0.042-16.394,0.438-22.717,1.177c-6.322,0.745-11.826,1.74-16.51,2.998c-4.641,1.254-8.637,2.716-11.856,4.385 c-3.263,1.669-6.31,3.454-9.096,5.357L1027.623,2659.932z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112593620221963653650000002886818718994055328_",
    gradientUnits: "userSpaceOnUse",
    x1: 771.8102,
    y1: 1410.8319,
    x2: 787.0625,
    y2: 1538.5156,
    gradientTransform: "matrix(-1 0 0 -1 1669.249 4127.8389)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#F36F56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3059,
    style: {
      stopColor: "#F99C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6817,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8038,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8667,
    style: {
      stopColor: "#FEBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    style: {
      stopColor: "#FCAD49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958,
    style: {
      stopColor: "#F99A4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9955,
    style: {
      stopColor: "#F58152"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F57E53"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000112593620221963653650000002886818718994055328_)"
    },
    d: "M889.366,2607.626 c-183.204,0-373.96,16.121-404.472,47.328c1.194,1.102,2.304,2.276,3.335,3.512c25.719-21.668,183.23-43.482,401.137-43.482 c223.502,0,383.538,22.951,402.924,45.153c0.952-1.218,1.971-2.383,3.072-3.481 C1270.161,2624.344,1075.824,2607.626,889.366,2607.626z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122685162738440910900000000011900740680415153_",
    gradientUnits: "userSpaceOnUse",
    x1: 506.7382,
    y1: 2631.9583,
    x2: 1452.1232,
    y2: 2631.9583
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB148"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0521,
    style: {
      stopColor: "#FDBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#F99C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    style: {
      stopColor: "#F8924F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8924F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122685162738440910900000000011900740680415153_)"
    },
    d: "M576.989,2559.731v91.135 c0,29.448,183.958,53.32,410.881,53.32c226.922,0,410.879-23.873,410.879-53.32v-91.135H576.989z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000149376403742000034030000000930986585589898379_",
    gradientUnits: "userSpaceOnUse",
    x1: 983.7754,
    y1: 2525.4639,
    x2: 1033.6151,
    y2: 2942.6956
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDB44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEEF06"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000149376403742000034030000000930986585589898379_)"
    },
    cx: 987.869,
    cy: 2559.73,
    rx: 410.88,
    ry: 53.321
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096754557434387670200000005494081278832895655_",
    gradientUnits: "userSpaceOnUse",
    x1: 981.6088,
    y1: 2506.8569,
    x2: 996.9155,
    y2: 2634.9956
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDB44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEEF06"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096754557434387670200000005494081278832895655_)"
    },
    d: "M987.868,2616.728 c-200.968,0-411.117-19.195-411.117-56.22c0-2.034,0.725-5.607,2.758-5.607c2.034,0,1.159,2.796,1.159,4.83 c0,23.479,167.232,49.64,407.2,49.64s407.2-26.161,407.2-49.64c0-2.034,0.347-3.94,2.38-3.94c2.034,0,1.543,2.713,1.543,4.747 C1398.991,2597.562,1188.837,2616.728,987.868,2616.728z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCB048"
    },
    d: "M949.043,2562.702c4.031-2.791,8.321-5.542,12.913-8.26c4.549-2.713,10.474-5.167,17.651-7.358 c7.219-2.191,16.247-3.974,27.086-5.357c10.838-1.382,24.389-2.111,40.57-2.19c15.88-0.077,30.772,0.427,44.721,1.514 c13.905,1.083,26.179,2.708,36.775,4.869c10.555,2.161,19.175,4.833,25.818,8.01c6.599,3.185,10.533,6.83,11.801,10.937 l46.264,0.469c3.357,0.021,6.328,0.293,8.87,0.821c2.585,0.527,3.836,1.193,3.84,2.001l0.019,3.809l-59.476-0.573 c-2.086,4.666-7.401,8.934-15.947,12.804c-8.502,3.875-19.372,7.226-32.613,10.062l-21.662-3.012 c-1.937-0.296-3.532-0.673-4.782-1.132c-1.251-0.454-1.855-0.949-1.858-1.489c-0.004-0.732,1.671-1.568,5.023-2.505 c3.353-0.942,7.133-2.105,11.344-3.494c4.21-1.383,8.334-3.019,12.412-4.909c4.037-1.885,6.737-4.138,8.143-6.762 l-140.385-1.391c-3.688,2.714-7.848,5.378-12.398,7.999c-4.591,2.62-10.648,4.981-18.211,7.074 c-7.564,2.095-16.981,3.794-28.249,5.103c-11.312,1.306-25.467,2-42.593,2.084c-12.868,0.063-25.393-0.426-37.663-1.459 c-12.269-1.039-23.165-2.592-32.686-4.659c-9.52-2.071-17.323-4.63-23.448-7.677c-6.083-3.051-9.5-6.553-10.209-10.514 l-38.087-0.39c-3.357-0.022-6.328-0.284-8.998-0.792c-2.628-0.508-3.966-1.183-3.969-2.028l-0.019-3.81l52.075,0.496 c2.304-4.013,7.02-7.512,14.236-10.489c7.214-2.98,16.024-5.631,26.426-7.95l17.441,2.395c5.296,0.744,7.926,1.614,7.931,2.616 c0.002,0.539-1.07,1.208-3.261,2.007c-2.234,0.801-4.811,1.758-7.819,2.867c-2.964,1.113-5.883,2.415-8.674,3.912 c-2.833,1.494-4.933,3.186-6.344,5.081L949.043,2562.702z M820.567,2567.893c1.046,2.499,3.38,4.648,6.918,6.457 c3.536,1.816,7.934,3.302,13.233,4.469c5.299,1.166,11.242,2.021,17.828,2.566c6.631,0.545,13.56,0.803,20.79,0.767 c8.434-0.041,15.792-0.406,22.071-1.09c6.237-0.688,11.74-1.617,16.512-2.796c4.729-1.179,8.896-2.542,12.417-4.1 c3.521-1.558,6.654-3.246,9.485-5.068L820.567,2567.893z M1126.181,2564.487c-1.045-2.531-3.595-4.75-7.563-6.657 c-3.969-1.902-9.055-3.507-15.215-4.801c-6.16-1.299-13.352-2.265-21.574-2.896c-8.18-0.631-17.219-0.925-27.115-0.876 c-8.78,0.042-16.395,0.437-22.717,1.178c-6.322,0.745-11.825,1.74-16.51,2.998c-4.641,1.254-8.637,2.716-11.856,4.385 c-3.263,1.669-6.31,3.455-9.097,5.357L1126.181,2564.487z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109014007431843161630000011687775360349151668_",
    gradientUnits: "userSpaceOnUse",
    x1: 673.2517,
    y1: 1506.2778,
    x2: 688.504,
    y2: 1633.9615,
    gradientTransform: "matrix(-1 0 0 -1 1669.249 4127.8389)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#F36F56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3059,
    style: {
      stopColor: "#F99C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6817,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8038,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8667,
    style: {
      stopColor: "#FEBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    style: {
      stopColor: "#FCAD49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958,
    style: {
      stopColor: "#F99A4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9955,
    style: {
      stopColor: "#F58152"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F57E53"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109014007431843161630000011687775360349151668_)"
    },
    d: "M987.924,2512.18 c-183.204,0-373.96,16.121-404.472,47.328c1.194,1.102,2.304,2.277,3.335,3.512c25.718-21.667,183.23-43.483,401.137-43.483 c223.502,0,383.538,22.952,402.924,45.153c0.952-1.218,1.97-2.383,3.072-3.48 C1368.719,2528.898,1174.383,2512.18,987.924,2512.18z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026870575286755507970000014083367217794812575_",
    gradientUnits: "userSpaceOnUse",
    x1: 455.4749,
    y1: 2536.2319,
    x2: 1400.859,
    y2: 2536.2319
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB148"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0521,
    style: {
      stopColor: "#FDBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#F99C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    style: {
      stopColor: "#F8924F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8924F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026870575286755507970000014083367217794812575_)"
    },
    d: "M525.725,2464.004v91.135 c0,29.449,183.957,53.321,410.88,53.321c226.922,0,410.879-23.873,410.879-53.321v-91.135H525.725z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112624566881513108290000015156806603272070572_",
    gradientUnits: "userSpaceOnUse",
    x1: 932.5116,
    y1: 2429.738,
    x2: 982.3515,
    y2: 2846.9709
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDB44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEEF06"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000112624566881513108290000015156806603272070572_)"
    },
    cx: 936.605,
    cy: 2464.004,
    rx: 410.88,
    ry: 53.321
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049222448504845711180000014796094502732363424_",
    gradientUnits: "userSpaceOnUse",
    x1: 930.3446,
    y1: 2411.1311,
    x2: 945.6511,
    y2: 2539.269
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDB44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEEF06"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049222448504845711180000014796094502732363424_)"
    },
    d: "M936.603,2521.001 c-200.968,0-411.117-19.195-411.117-56.219c0-2.034,0.725-5.607,2.758-5.607c2.034,0,1.159,2.795,1.159,4.829 c0,23.48,167.233,49.641,407.2,49.641c239.969,0,407.2-26.161,407.2-49.641c0-2.034,0.347-3.939,2.38-3.939 c2.034,0,1.543,2.714,1.543,4.747C1347.727,2501.835,1137.573,2521.001,936.603,2521.001z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105421273824075708290000009238892566014011274_",
    gradientUnits: "userSpaceOnUse",
    x1: 724.5156,
    y1: 1602.0037,
    x2: 739.7678,
    y2: 1729.6874,
    gradientTransform: "matrix(-1 0 0 -1 1669.249 4127.8389)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#F36F56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3059,
    style: {
      stopColor: "#F99C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6817,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8038,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8667,
    style: {
      stopColor: "#FEBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    style: {
      stopColor: "#FCAD49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958,
    style: {
      stopColor: "#F99A4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9955,
    style: {
      stopColor: "#F58152"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F57E53"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000105421273824075708290000009238892566014011274_)"
    },
    d: "M936.66,2416.454 c-183.204,0-373.96,16.121-404.472,47.328c1.194,1.101,2.305,2.277,3.335,3.512c25.718-21.668,183.23-43.483,401.137-43.483 c223.502,0,383.538,22.952,402.924,45.153c0.952-1.217,1.971-2.384,3.073-3.48 C1317.456,2433.172,1123.119,2416.454,936.66,2416.454z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178907228198612759740000014237232693052877499_",
    gradientUnits: "userSpaceOnUse",
    x1: 1743.019,
    y1: 2282.281,
    x2: 2688.4075,
    y2: 2282.281,
    gradientTransform: "matrix(0.5796 0.8149 -0.8149 0.5796 2214.3765 -230.3409)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB148"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0521,
    style: {
      stopColor: "#FDBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#F99C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    style: {
      stopColor: "#F8924F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8924F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178907228198612759740000014237232693052877499_)"
    },
    d: "M1464.359,2528.251l-74.265,52.824 c-23.998,17.07,63.176,180.809,194.706,365.724c131.531,184.915,257.611,320.982,281.608,303.912l74.264-52.824 L1464.359,2528.251z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034081730104593710970000009525679650178348198_",
    gradientUnits: "userSpaceOnUse",
    x1: 2220.0569,
    y1: 2175.7979,
    x2: 2269.8906,
    y2: 2592.9788,
    gradientTransform: "matrix(0.5796 0.8149 -0.8149 0.5796 2214.3765 -230.3409)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDB44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEEF06"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034081730104593710970000009525679650178348198_)"
    },
    d: "M1940.673,3197.887 c-23.997,17.069-150.077-118.996-281.607-303.912c-131.531-184.915-218.704-348.655-194.706-365.724 c23.997-17.07,150.077,118.996,281.607,303.911C1877.496,3017.078,1964.67,3180.818,1940.673,3197.887z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000019646500905279322720000010532375759379268776_",
    gradientUnits: "userSpaceOnUse",
    x1: 2217.8901,
    y1: 2157.2,
    x2: 2233.1941,
    y2: 2285.3167,
    gradientTransform: "matrix(0.5796 0.8149 -0.8149 0.5796 2214.3765 -230.3409)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDB44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEEF06"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000019646500905279322720000010532375759379268776_)"
    },
    d: "M1656.068,2896.105 c-116.487-163.766-222.653-346.139-192.483-367.599c1.657-1.178,4.99-2.658,6.168-1.002c1.178,1.657-1.607,2.565-3.264,3.743 c-19.133,13.609,56.481,165.047,195.574,360.593c139.092,195.546,257.342,316.657,276.476,303.047 c1.657-1.178,3.41-2,4.589-0.343c1.178,1.656-1.317,2.83-2.974,4.008C1909.985,3220.014,1772.555,3059.871,1656.068,2896.105z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116921978583489391930000001437808723729564557_",
    gradientUnits: "userSpaceOnUse",
    x1: -562.4606,
    y1: 1855.5052,
    x2: -547.2112,
    y2: 1983.1653,
    gradientTransform: "matrix(-0.5796 -0.8149 0.8149 -0.5796 -181.2018 3522.6223)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#F36F56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3059,
    style: {
      stopColor: "#F99C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6817,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8038,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8667,
    style: {
      stopColor: "#FEBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    style: {
      stopColor: "#FCAD49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958,
    style: {
      stopColor: "#F99A4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9955,
    style: {
      stopColor: "#F58152"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F57E53"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116921978583489391930000001437808723729564557_)"
    },
    d: "M1741.295,2835.554 c-106.19-149.29-229.894-295.389-273.01-302.165c-0.204,1.612-0.518,3.197-0.929,4.753 c32.564,8.399,141.639,124.106,267.944,301.676c129.548,182.128,203.606,325.841,196.751,354.507 c1.544,0.07,3.085,0.224,4.618,0.487C1948.392,3155.546,1849.372,2987.495,1741.295,2835.554z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025425733913238843340000018339334701236619943_",
    gradientUnits: "userSpaceOnUse",
    x1: -3603.4968,
    y1: 1881.9945,
    x2: -3587.9417,
    y2: 1972.6934,
    gradientTransform: "matrix(1 0 0 1 6229.0884 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000025425733913238843340000018339334701236619943_)"
    },
    d: "M2598.243,1918.031 c5.202-4.176,12.091-10.997,16.04-21.144c4.233-10.875,1.253-15.718,6.562-22.51c6.732-8.615,20.506-12.32,29.954-8.112 c1.992,0.887,4.417,2.125,5.944,4.704c4.201,7.092-5.124,19.377-12.567,25.918c-5.602,4.923-7.917,4.559-13.853,8.75 c-5.795,4.089-13.091,11.14-18.957,24.06L2598.243,1918.031z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103972858543445292130000000684916755624794038_",
    gradientUnits: "userSpaceOnUse",
    x1: 4467.9702,
    y1: 223.7055,
    x2: 4483.5259,
    y2: 314.4093,
    gradientTransform: "matrix(-0.9207 0.3902 0.3902 0.9207 6896.9482 -113.3621)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103972858543445292130000000684916755624794038_)"
    },
    d: "M2909.82,1858.515 c-6.419-1.816-15.423-5.408-23.019-13.209c-8.141-8.362-7.287-13.983-14.825-18.166c-9.56-5.305-23.688-3.343-30.745,4.218 c-1.488,1.594-3.238,3.681-3.637,6.651c-1.101,8.169,12.279,15.842,21.684,18.96c7.079,2.348,9.068,1.109,16.169,2.65 c6.931,1.504,16.4,5.149,26.842,14.757L2909.82,1858.515z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143602078336281201870000010144709509341702824_",
    gradientUnits: "userSpaceOnUse",
    x1: 4278.2065,
    y1: 878.2278,
    x2: 4400.3872,
    y2: 1590.635,
    gradientTransform: "matrix(-0.9612 0.2758 0.2758 0.9612 6784.645 -63.5757)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000143602078336281201870000010144709509341702824_)"
    },
    d: "M2880.044,1868.62 c-4.138,19.7,17.16,37.227,32.524,54.436c30.819,34.519,63.079,96.113,51.235,148.973c-6.469,28.874-27.208,60.096-56.492,74.894 c-31.519,15.927-50.4,1.437-83.186,20.35c-2.417,1.395-43.88,25.977-45.084,59.149c-1.485,40.924,58.683,84.461,110.188,87.793 c94.198,6.094,207.697-119.173,202.409-243.476c-5.757-135.322-151.159-242.733-192.99-224.523 C2892.061,1849.084,2882.373,1857.533,2880.044,1868.62z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101786358545863873570000017244928480015714701_",
    gradientUnits: "userSpaceOnUse",
    x1: 3229.8806,
    y1: 3244.8496,
    x2: 3229.8806,
    y2: 2909.8914,
    gradientTransform: "matrix(-0.9994 0.0352 0.0352 0.9994 5963.9233 -10.261)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000101786358545863873570000017244928480015714701_)"
    },
    points: "2838.119,3269.844  2834.745,3304.126 2850.712,3301.23 2861.444,3269.02  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044150605428608143130000006640335986524872332_",
    gradientUnits: "userSpaceOnUse",
    x1: 3198.6138,
    y1: 2601.2957,
    x2: 3171.3521,
    y2: 3214.6843,
    gradientTransform: "matrix(-0.9994 0.0352 0.0352 0.9994 5963.9233 -10.261)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044150605428608143130000006640335986524872332_)"
    },
    d: "M2935.415,2636.366 c-1.66,60.876-9.253,112.975-18.25,155.507c-9.679,45.754-15.316,53.66-18.336,85.298c-6.567,68.847,15.62,78.702,19.694,156.52 c4.5,85.926-18.349,154.219-27.331,180.27c-7.853,22.774-16.072,41.166-22.254,53.94c-7.878,6.869-19.924,4.231-32.624,1.649 c-4.68-77.938-10.512-151.284-15.192-229.222c-15.089-117.246-30.177-234.487-45.266-351.731 C2829.043,2671.185,2882.229,2653.778,2935.415,2636.366z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049219946508878005510000013867092225768498084_",
    gradientUnits: "userSpaceOnUse",
    x1: 3198.6138,
    y1: 2601.2957,
    x2: 3171.3521,
    y2: 3214.6841,
    gradientTransform: "matrix(-0.9994 0.0352 0.0352 0.9994 5963.9233 -10.261)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000049219946508878005510000013867092225768498084_)"
    },
    d: "M2836.315,3269.55 c-4.68-77.938-10.512-151.284-15.192-229.222c-15.089-117.246-30.177-234.487-45.266-351.731 c53.186-17.412,106.372-34.82,159.558-52.231c-0.11,4.031-0.313,7.918-0.472,11.875c-74.62,64.801-89.224,116.136-88.494,151.15 c0.884,42.467,24.106,63.519,19.569,125.093c-3.244,44.026-16.479,51.782-16.474,91.51c0.008,51.156,21.964,79.92,32.658,109.481 c10.334,28.572,14.012,69.04-5.953,126.598c-2.622,5.944-5.099,11.263-7.31,15.829 C2861.06,3274.768,2849.015,3272.135,2836.315,3269.55z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000038394255396018283920000009348614875192633751_",
    gradientUnits: "userSpaceOnUse",
    x1: 3257.5713,
    y1: 3246.5784,
    x2: 3201.532,
    y2: 3061.7998,
    gradientTransform: "matrix(-0.9994 0.0352 0.0352 0.9994 5963.9233 -10.261)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000038394255396018283920000009348614875192633751_)"
    },
    d: "M2844.108,3315.82 c7.558-9.369,14.5-8.682,15.76-15.036c0.992-4.992-2.183-11.021-6.823-13.238c-6.522-3.114-14.228,2.135-15.969,3.319 c-11.827,8.054-8.299,20.178-19.495,25.708c-2.254,1.114-5.836,2.32-9.563,5.964c-1.581,1.548-5.5,5.38-4.507,7.941 c1.146,2.962,8.275,2.707,15.052,2.462c8.132-0.291,12.198-0.435,16.058-2.961 C2839.973,3326.479,2838.274,3323.05,2844.108,3315.82z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000149380134525255880610000006024538149724880035_",
    gradientUnits: "userSpaceOnUse",
    x1: 4667.5073,
    y1: -910.7007,
    x2: 4667.5073,
    y2: -1207.5677,
    gradientTransform: "matrix(-0.6521 0.7581 0.7581 0.6521 6622.4819 112.2658)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000149380134525255880610000006024538149724880035_)"
    },
    points: "2828.056,3022.521  2857.916,3034.208 2866.62,3020.512 2843.275,3004.825  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078006994682576951380000016213269348578154422_",
    gradientUnits: "userSpaceOnUse",
    x1: 4688.147,
    y1: -899.4764,
    x2: 4632.105,
    y2: -1084.2634,
    gradientTransform: "matrix(-0.6521 0.7581 0.7581 0.6521 6622.4819 112.2658)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078006994682576951380000016213269348578154422_)"
    },
    d: "M2873.645,3041.455 c-1.755-11.907,3.458-16.542-0.355-21.779c-2.995-4.115-9.578-5.873-14.354-3.968c-6.712,2.68-8.084,11.901-8.396,13.983 c-2.105,14.155,9.196,19.787,5.663,31.764c-0.711,2.411-2.255,5.862-2.105,11.072c0.064,2.211,0.221,7.691,2.776,8.699 c2.954,1.167,7.602-4.244,12.02-9.389c5.303-6.172,7.957-9.257,8.718-13.806 C2878.671,3051.725,2874.999,3050.647,2873.645,3041.455z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106115602966410462360000006765997092507338937_",
    gradientUnits: "userSpaceOnUse",
    x1: -3142.1829,
    y1: 2823.6819,
    x2: -3713.9165,
    y2: 2797.6936,
    gradientTransform: "matrix(1 0 0 1 6229.0884 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106115602966410462360000006765997092507338937_)"
    },
    d: "M2698.86,2582.248 c-55.626,113.428-74.515,208.01-81.66,269.77c-4.594,39.713-4.15,64.274,7.291,88.951 c40.955,88.335,183.885,94.168,205.608,94.784c7.145-14.634,14.29-29.268,21.434-43.902 c-13.149-24.389-36.097-58.255-75.388-82.962c-30.218-19.002-42.035-14.938-49.58-27.706 c-30.271-51.237,133.134-162.204,108.723-236.076C2826.844,2619.55,2794.339,2593.636,2698.86,2582.248z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054977116030161535530000017248820519805399716_",
    gradientUnits: "userSpaceOnUse",
    x1: -3369.3533,
    y1: 1925.1025,
    x2: -3227.1772,
    y2: 2754.0959,
    gradientTransform: "matrix(1 0 0 1 6229.0884 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054977116030161535530000017248820519805399716_)"
    },
    d: "M2819.401,2174.5 c-60.11,10.324-105.874,21.069-126.306,52.551c-21.581,33.254,12.73,58.285,22.06,131.244 c14.285,111.699-49.937,153.426-31.458,265.896c3.015,18.353,7.593,34.693,12.519,48.642c8.664,24.53,25.47,45.176,47.494,59.023 c16.515,10.383,36.592,20.829,60.152,29.072c60.952,21.322,91.019,8.927,173.026,13.612 c134.136,7.664,154.22,46.568,214.82,22.646c61.248-24.179,105.577-89.511,92.588-117.429 c-7.78-16.719-32.321-6.28-67.518-26.805c-45.36-26.453-37.741-62.56-74.544-93.533c-52.863-44.488-103.714,0.439-148.928-38.245 c-45.736-39.135-51.195-134.299-31.755-190.951c12.698-37.003,12.935-77.244,22.357-115.211c0.784-3.155,1.4-8.186-0.561-13.892 c-7.497-21.821-47.427-26.01-77.61-28.894C2859.705,2167.828,2824.344,2173.649,2819.401,2174.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158739432073216482010000003255433403830948277_",
    gradientUnits: "userSpaceOnUse",
    x1: -674.7141,
    y1: 1784.774,
    x2: -397.8907,
    y2: 2354.0171,
    gradientTransform: "matrix(0.9781 -0.2085 0.2085 0.9781 2923.366 366.1276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000158739432073216482010000003255433403830948277_)"
    },
    d: "M3184.672,2754.826 c-18.571-12.375-8.513-47.459-36.019-66.084c-25.529-17.286-45.44,5.321-83.065-6.213 c-48.256-14.795-45.733-61.255-91.978-76.084c-33.255-10.662-43.287,10.565-91.253,11.481 c-47.884,0.917-110.656-18.845-150.406-69.605c-16.89-21.568-26.326-44.578-31.463-65.851 c-12.805,41.365-26.708,81.353-16.791,141.719c4.014,24.43,10.795,45.292,17.484,61.699c6.24,15.306,16.771,28.455,30.339,37.897 c18.472,12.854,42.638,26.749,72.343,37.139c60.951,21.323,91.019,8.928,173.026,13.614 c134.136,7.664,154.22,46.568,214.82,22.646c39.144-15.452,71.29-47.695,86.065-76.256 C3224.761,2759.491,3198.15,2763.808,3184.672,2754.826z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078020878148489228810000012972459008685250486_",
    gradientUnits: "userSpaceOnUse",
    x1: 3265.0527,
    y1: 2010.7955,
    x2: 3201.1211,
    y2: 2114.2141,
    gradientTransform: "matrix(-0.9994 0.0352 0.0352 0.9994 5963.9233 -10.261)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078020878148489228810000012972459008685250486_)"
    },
    d: "M2784.681,2070.469 c0,0-16.565,31.095-17.609,52.916c-1.045,21.819,23.579,20.234,23.579,20.234l-0.925,13.764 c-0.789,11.75-8.416,21.937-19.469,26.001l-9.723,3.575c0,0,63.422,13.578,98.054-10.889l-9.98-0.977 c-14.132-1.383-25.331-12.535-26.772-26.662l-0.602-5.891C2821.235,2142.539,2832.236,2074.525,2784.681,2070.469z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114774860729047834050000001260750048622438327_",
    gradientUnits: "userSpaceOnUse",
    x1: -3608.5095,
    y1: 2022.0951,
    x2: -3486.3303,
    y2: 2734.4919,
    gradientTransform: "matrix(1 0 0 1 6229.0884 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114774860729047834050000001260750048622438327_)"
    },
    d: "M2628.501,1924.229 c9.411,17.795-6.228,40.515-16.25,61.295c-20.104,41.68-34.126,109.782-8.162,157.325c14.182,25.969,42.726,50.261,74.956,56.408 c34.689,6.616,48.842-12.518,85.572-3.38c2.709,0.673,49.343,12.866,59.649,44.42c12.714,38.927-33.113,97.37-81.7,114.778 c-88.864,31.837-232.51-57.27-261.708-178.21c-31.788-131.662,78.352-275.008,123.583-269.04 C2611.562,1908.764,2623.205,1914.214,2628.501,1924.229z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106134034820410559980000001470562474690707615_",
    gradientUnits: "userSpaceOnUse",
    x1: 2909.9795,
    y1: 2443.9661,
    x2: 3168.4404,
    y2: 1891.6992,
    gradientTransform: "matrix(-0.9994 0.0352 0.0352 0.9994 5963.9233 -10.261)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106134034820410559980000001470562474690707615_)"
    },
    d: "M2794.59,2101.391 c3.278-0.271,5.986-4.429,8.23-3.194c2.356,1.293,2.094,7.354,0.048,11.609c-1.68,3.486-4.419,5.457-5.943,6.377 c2.531,3.503,5.756,8.948,7.098,16.075c2.97,15.763-5.41,28.442-8.893,35.86c-15.708,33.444,8.729,86.319,35.549,113.021 c21.797,21.705,31.967,12.977,44.979,30.704c25.329,34.502-9.631,72.426,3.469,118.863 c19.918,70.61,131.415,91.617,136.037,92.43c1.821,0.322,3.043,0.523,4.939,0.824c50.017,7.946,125.826,19.989,179.214-21.063 c39.945-30.713,58.264-84.172,55.238-131.257c-0.795-12.385-4.547-59.401-42.856-97.773c-6.082-6.09-42.087-42.072-90.743-42.507 c-25.77-0.232-30.966,8.849-50.675,3.235c-26.982-7.687-43.601-32.218-53.913-47.434c-18.965-27.991-11.258-33.967-24.902-47.734 c-26.736-26.97-58.103-5.791-86.658-29.594c-28.149-23.462-11.167-55.291-38.339-75.6c-28.03-20.944-81.648-13.631-93.077,11.311 C2763.57,2066.976,2784.541,2102.221,2794.59,2101.391z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangepieceRatehubwise);
export default __webpack_public_path__ + "static/media/changepieceRatehubwise.44d9a64b.svg";
export { ForwardRef as ReactComponent };